import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import useRegistrationFormService from "./service";
import TicketRejectInfoModal from "../../components/ticketRejectInfoModal";
import TicketStatus from "../../../../shared/enums/TicketStatus";
import RegistrationStatus from "../../../../shared/enums/RegistrationStatus";

/**
 * @name RegistrationForm
 * @description To render form based on argument passed in url
 * @constructor
 */

export default function RegistrationForm() {
  const navigate = useNavigate();
  const regFormService = useRegistrationFormService();

  React.useEffect(() => {
    if (
      !regFormService.formId &&
      !regFormService.regParticipationId &&
      !regFormService.invoicePaymentRequestId &&
      !regFormService.invoicePayerId
    ) {
      navigate("/", { replace: true });
    }
  }, [
    regFormService.formId,
    regFormService.regParticipationId,
    regFormService.invoicePaymentRequestId,
    regFormService.invoicePayerId,
    navigate
  ]);

  if (!regFormService.participantObj && !regFormService.regFormDetails && !regFormService.transactionDetails) {
    return null;
  }

  if (regFormService.regFormDetails?.adminFlow) {
    return <h1>This Form is not supported</h1>;
  }

  return (
    <React.Fragment>
      <Outlet
        context={{
          participantObj: regFormService.participantObj,
          setParticipantData: regFormService.setParticipantData,
          regFormDetailObj: regFormService.regFormDetails,
          transactionDetails: regFormService.transactionDetails,
          updatePaymentDetails: regFormService.updatePaymentDetails,
          refetchParticipantDetails: regFormService.refetchParticipantDetails,
          refetchInvoicePaymentRequest: regFormService.refetchInvoicePaymentRequest
        }}
      />
      <TicketRejectInfoModal
        ticketStatus={regFormService.participantObj?.ticketStatus as TicketStatus}
        registrationStatus={regFormService.participantObj?.registrationStatus as RegistrationStatus}
      />
    </React.Fragment>
  );
}
